import React, { useEffect, useState } from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown, Modal } from 'react-bootstrap';
import { getAuth, signOut, updatePassword, onAuthStateChanged, EmailAuthProvider, reauthenticateWithCredential  } from "firebase/auth";
import SideNav from '../components/SideNav';
import { OrderSummaryCards } from './OrderPage';
import Topbar from '../components/Topbar';
import NotificationDropdown from '../components/NotificationDropdown'; // New notification component
import LeadForm from './LeadForm';


function Dashboard() {

    const userUId = window.localStorage.getItem('projectUserUID');
    const userROLE = window.localStorage.getItem('projectUserRole');


      // Password reset modal states
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [currentUser, setCurrentUser] = useState(userUId);

  useEffect(() => {
    const auth = getAuth();
    
    // Check if user needs to change password
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
        
        // Get ID token to check custom claims
        user.getIdTokenResult().then((idTokenResult) => {
          if (idTokenResult.claims.firstLogin) {
            setShowPasswordModal(true);
          }
        });
      }
    });
  }, []);

  const handlePasswordReset = async () => {
    if (newPassword !== confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    
    if (newPassword.length < 6) {
      setPasswordError('Password must be at least 6 characters long');
      return;
    }

 try {
    await updatePassword(currentUser, newPassword);

    const response = await fetch('https://api-4h4srbodqa-uc.a.run.app/remove-first-login-flag', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ uid: currentUser.uid })
    });

    if (response.ok) {
      // ✅ Force refresh the ID token so stale claims are cleared
      await currentUser.getIdToken(true);

      setShowPasswordModal(false);
      setPasswordError('');
    } else {
      setPasswordError('Failed to update password status');
    }
  } catch (error) {
    setPasswordError('Failed to update password: ' + error.message);
  }
};

//   const handlePasswordReset = async () => {
//   setPasswordError('');

//   if (newPassword !== confirmPassword) {
//     setPasswordError('Passwords do not match');
//     return;
//   }

//   if (newPassword.length < 6) {
//     setPasswordError('Password must be at least 6 characters long');
//     return;
//   }

//   try {
//     // Re-authenticate first (get currentPassword from input field)
//     const credential = EmailAuthProvider.credential(currentUser.email, currentPassword);
//     await reauthenticateWithCredential(currentUser, credential);

//     // Update password
//     await updatePassword(currentUser, newPassword);

//     // Call backend
//     const response = await fetch('https://api-4h4srbodqa-uc.a.run.app/remove-first-login-flag', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ uid: currentUser.uid })
//     });

//     if (response.ok) {
//       setShowPasswordModal(false);
//     } else {
//       setPasswordError('Failed to update password status');
//     }

//   } catch (error) {
//     console.error(error);
//     if (error.code === 'auth/requires-recent-login') {
//       setPasswordError('Please log in again before changing your password.');
//     } else {
//       setPasswordError('Password update failed: ' + error.message);
//     }
//   }
// };



    const handleLogOut = () => {
        const auth = getAuth();
        signOut(auth).then(() => {
            window.localStorage.clear();
        // Sign-out successful.
        }).catch((error) => {
        // An error happened.
        });
    }
  return (
    <>
   <Container fluid className='p-3' style={{backgroundColor:"#F9FAFB", height:"100vh",}}>
    <Row>
        <Col className='col-auto' >
        <SideNav />
        </Col>
    
        <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
                    <Row className='p-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                        <Col><h4 style={{ color: "#000" }}>{userROLE === 'preSales' ? "Lead Form" : "Dashboard"}</h4></Col>
                        <Col className="d-flex justify-content-end align-items-center">
                        {/* <NotificationDropdown userId={userUId} /> */}
                            {/* <Image src={require('../assets/notification.png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px', }} /> */}
                            <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                        </Col>
                    </Row>
                    <Row className='p-2 mt-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                       {/* Main Body Part */}
                       {/* {userROLE === 'preSales' ? 
                       <LeadForm />:  <OrderSummaryCards  />  } */}
                        <OrderSummaryCards  />  
                    </Row>
        
                </Col>
        </Row>
   </Container>

     {/* Password Reset Modal */}
      <Modal show={showPasswordModal} onHide={() => {}} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title>Change Your Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>For security reasons, you must change your password before continuing.</p>
          <Form>
           {/* <Form.Group className="mb-3">
              <Form.Label>Current Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </Form.Group> */}
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
            {passwordError && <p style={{color: 'red'}}>{passwordError}</p>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handlePasswordReset}>
            Update Password
          </Button>
        </Modal.Footer>
      </Modal>
      </>
  ) 
}

export default Dashboard